













import Vue from 'vue'

export default Vue.extend({
  name: 'tweet-button',
  props: {
    url: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: false
    },
    via: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false
    }
  }
})
